import React from "react";
import Video from "./Video";
import {
  useCreateVideoMutation,
  useGetVideosQuery,
} from "../../../features/videos/videosApi";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal);

const Videos = () => {
  const { data: videos, isError, isLoading, error } = useGetVideosQuery();

  const [addVideo] = useCreateVideoMutation();

  const handleAddVideo = async () => {
   await MySwal.fire({
      width: 800,
      showCancelButton: true,
      confirmButtonText: "Add Video",
      showLoaderOnConfirm: true,
      background: "#080E1B",
      html: `
      <div class="flex flex-col gap-y-2">
        <label for="title" class="text-white text-left mb-3 font-semibold">Title</label>
        <input required id="title" placeholder="Enter video title" class="input input-bordered input-primary w-full text-white" value="" />
        <label for="url" class="text-white text-left my-3 font-semibold">Video URL</label>
        <input required id="url" placeholder="Enter embeded video link from youtube" class="input input-bordered input-primary w-full text-white" value="" />
        <label for="duration" class="text-white text-left my-3 font-semibold">Video Duration</label>
        <input required id="duration" placeholder="Enter video duration" class="input input-bordered input-primary w-full text-white" value="" />
        <label for="description" class="text-white text-left my-3 font-semibold">Description</label>
        <textarea required id="description" class="textarea textarea-primary text-white h-28" placeholder="Enter video description"></textarea>
      </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          title: document.getElementById("title").value,
          url: document.getElementById("url").value,
          duration: document.getElementById("duration").value,
          description: document.getElementById("description").value,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { title, url, duration, description } = result.value;
        if (!title || !url || !duration || !description) {
          MySwal.fire({
            icon: "error",
            title: "<span class='text-white'>Oops...</span>",
            text: "All fields are required",
            background: "#080E1B",
          });
          return;
        }
        const createdAt = new Date().toISOString();
        addVideo({ title, description, url, views: "0", duration, createdAt });
      }
    });
  };

  // decide what to show based on the state
  let content = null;
  if (isLoading) {
    content = (
      <tr>
        <td>Loading...</td>
      </tr>
    );
  }
  if (!isLoading && isError) {
    content = (
      <tr>
        <td>{error.message}</td>
      </tr>
    );
  }
  if (!isLoading && !isError && videos.length > 0) {
    content = videos.map((video) => <Video key={video.id} video={video} />);
  }

  return (
    <div className="mx-auto max-w-full px-5 lg:px-20">
      <div className="px-3 py-20 bg-opacity-10">
        <div className="w-full flex">
          <button className="btn ml-auto" onClick={handleAddVideo}>
            Add Video
          </button>
        </div>
        <div className="overflow-x-auto mt-4">
          <table className="divide-y-1 text-base divide-gray-600 w-full">
            <thead>
              <tr>
                <th className="table-th">Video Title</th>
                <th className="table-th">Description</th>
                <th className="table-th">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-600/50">{content}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Videos;
